import { type MeResponse, NOTION_ROLES, type RoleCode } from "@seagames/contracts";

/**
 * Who may use WSL Notion: the SUPER_ADMIN active role (`NOTION_ROLES`) and
 * nobody else — decided by the ACTIVE role only (one active role per session,
 * CLAUDE.md § Auth invariants). A super admin acting as ADMIN gets the
 * no-access screen with "Continue as Super Admin".
 *
 * The API fences every /notion route on the same list; this only says so up front.
 */
export type NotionAccess = "member" | "none";

const includes = (list: readonly RoleCode[], role: RoleCode | null | undefined): boolean => role != null && list.includes(role);

export function notionAccessFor(role: RoleCode | null | undefined): NotionAccess {
	return includes(NOTION_ROLES, role) ? "member" : "none";
}

/** Held roles (other than the active one) that WOULD open WSL Notion — for the no-access screen's switcher. */
export function usableOtherRoles(session: MeResponse): RoleCode[] {
	return session.roles.map((r) => r.code).filter((code) => code !== session.active_role && notionAccessFor(code) !== "none");
}

/** The role the sign-in form asks for: WSL Notion never signs in as anything else. */
export const NOTION_SIGN_IN_ROLE: RoleCode = NOTION_ROLES[0];
